var juuls     = juuls || {};
juuls.klaviyo = {
    init: function () {
        juuls.klaviyo.bindEvents();
    },
    bindEvents: function () {
        jQuery( document )
                .on( 'productadded.e4.cart', juuls.klaviyo.addtoCart )
    },
    addtoCart: function ( event, objData ) {
        var objTracking = [
            'track',
            'Added to Cart',
            {
                '$value': objData.cart.priceClean,
                'AddedItemProductName': objData.cart.lastAddedOrderlineData.name,
                'AddedItemProductID': objData.cart.lastAddedOrderlineData.id,
                'AddedItemSKU': objData.cart.lastAddedOrderlineData.number,
                'AddedItemCategories': objData.cart.lastAddedOrderlineData.categories,
                'AddedItemImageURL': objData.cart.lastAddedOrderlineData.image,
                'AddedItemURL': objData.cart.lastAddedOrderlineData.link,
                'AddedItemPrice': objData.cart.lastAddedOrderlineData.price,
                'AddedItemQuantity': objData.cart.lastAddedOrderlineData.quantity,
                'ItemNames': objData.cart.orderlineNames,
                'CheckoutURL': `${location.origin}/shop/cart/checkout`,
                'Items': objData.cart.orderlinesData
            }
        ];
        if(window._learnq !== undefined){
            window._learnq.push(objTracking);
        }
    }
}